import { getMethod, patchMethod } from '../../api/methods'
import API_ROUTES from '../../api/routes'
import { apiParams } from '../../utils'

const {
  GET_INVENTORY_LIST,
  QUICK_EDIT,
  PROCESS_ELV,
  GET_GENERATED_REPORT,
  UPDATE_VEHICLE_DISPATCH_DATE,
  SEARCH_INVENTORY,
  GET_SCRAP_MATERIALS,
  GET_SCRAP_LIST_ON_MATERIAL_TYPE,
  GET_INFO_TILL_JOB,
  GET_CONNECTED_JOBS,
  UPDATE_SCRAP_CREDIT_NOTE,
} = API_ROUTES

const getInventoryListApi = async ({ params }) => {
  const response = await getMethod(GET_INVENTORY_LIST({ params }))
  return response?.data
}

const patchProcessToggleApi = async ({ payload }) => {
  const response = await patchMethod(QUICK_EDIT, payload)
  return response?.data
}
const processElvApi = async ({ payload }) => {
  const response = await patchMethod(PROCESS_ELV, payload)
  return response?.data
}

const getGeneratedReportApi = async ({ params }) => {
  const response = await getMethod(GET_GENERATED_REPORT({ params }))
  return response?.data
}

const updateVehicleDispatchDateApi = async ({ payload }) => {
  const response = await patchMethod(UPDATE_VEHICLE_DISPATCH_DATE, payload)
  return response?.data
}

const searchInventoryApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    SEARCH_INVENTORY({ params: apiParams({ params, pageNo }) }),
  )
  return response?.data
}

const getScrapMaterialsApi = async ({ params }) => {
  const response = await getMethod(GET_SCRAP_MATERIALS({ params }))
  return response?.data
}

const getScrapListOnMaterialTypeApi = async ({ params }) => {
  const response = await getMethod(GET_SCRAP_LIST_ON_MATERIAL_TYPE({ params }))
  return response?.data
}

const getInfoTillJobApi = async ({ params }) => {
  const response = await getMethod(GET_INFO_TILL_JOB({ params }))
  return response?.data
}

const getConnectedJobsApi = async ({ jobId, page = 1 }) => {
  const response = await getMethod(GET_CONNECTED_JOBS({ jobId, page }))
  return response?.data
}

const updateScrapCreditNoteApi = async ({ payload }) => {
  const response = await patchMethod(UPDATE_SCRAP_CREDIT_NOTE, payload)
  return response?.data
}

export {
  getInventoryListApi,
  patchProcessToggleApi,
  processElvApi,
  getGeneratedReportApi,
  updateVehicleDispatchDateApi,
  searchInventoryApi,
  getScrapMaterialsApi,
  getScrapListOnMaterialTypeApi,
  getInfoTillJobApi,
  getConnectedJobsApi,
  updateScrapCreditNoteApi,
}
